import { useEffect, useState, useCallback } from "react";
import "@/App.css";
import Lenis from "lenis";
import { Toaster } from "@/components/ui/sonner";
import { translations } from "@/i18n";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import Manifesto from "@/components/Manifesto";
import Services from "@/components/Services";
import Corridors from "@/components/Corridors";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";
import ChatWidget from "@/components/ChatWidget";

const GRAIN =
  "url(\"data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='140' height='140'><filter id='n'><feTurbulence type='fractalNoise' baseFrequency='0.85' numOctaves='2'/></filter><rect width='140' height='140' filter='url(%23n)'/></svg>\")";

export default function App() {
  const [lang, setLang] = useState(() => localStorage.getItem("hk-lang") || "en");
  const t = translations[lang];

  useEffect(() => {
    localStorage.setItem("hk-lang", lang);
    document.documentElement.lang = lang;
  }, [lang]);

  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    window.__lenis = lenis;
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
    };
  }, []);

  const scrollTo = useCallback((id) => {
    const el = document.getElementById(id);
    if (!el) return;
    if (window.__lenis) window.__lenis.scrollTo(el, { offset: -70 });
    else el.scrollIntoView({ behavior: "smooth" });
  }, []);

  return (
    <div
      className="relative min-h-screen bg-cream font-sans text-forest antialiased"
      data-testid="app-root"
    >
      <div
        aria-hidden
        className="pointer-events-none fixed inset-0 z-[5] opacity-[0.05] mix-blend-multiply"
        style={{ backgroundImage: GRAIN }}
      />
      <Navbar t={t} lang={lang} setLang={setLang} scrollTo={scrollTo} />
      <main>
        <Hero t={t} scrollTo={scrollTo} />
        <Marquee t={t} />
        <Manifesto t={t} />
        <Services t={t} />
        <Corridors t={t} />
        <Contact t={t} />
      </main>
      <Footer t={t} scrollTo={scrollTo} />
      <ChatWidget t={t} />
      <Toaster position="bottom-center" />
    </div>
  );
}
